export default "/fonts/vendor/katex/dist/KaTeX_Fraktur-Bold.ttf?4c761b3711973ab04edf7ea6f1fbacdc";